import React, { useCallback } from "react";

import { DelayedActionToast } from "@swiggy-private/dls-web-recipe-food-web/dist/components/DelayedActionToast";
import { ToastActionType, useDelayedActionToast } from "@swiggy-private/portal-dineout-context";

/**
 * Renderer component that connects context state to DLS DelayedActionToast component
 * This bridges the gap between state management (context) and UI rendering (DLS component)
 *
 * Usage: Place this component anywhere in your app where you want the toast to appear
 */
export const DelayedActionToastRenderer: React.FC = () => {
    const { toastState, dispatch } = useDelayedActionToast();

    const handleUnmount = useCallback(() => {
        toastState?.props.onUnmount?.();
        dispatch({ type: ToastActionType.HIDE_TOAST });
    }, [dispatch, toastState?.props]);

    // Don't render if no toast state action or not visible
    if (!toastState?.isVisible || !toastState?.props.onAction) {
        return null;
    }

    return (
        <div style={toastState.style ? { ...toastState.style } : undefined}>
            <DelayedActionToast {...toastState.props} onUnmount={handleUnmount} />
        </div>
    );
};
